import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-secondary-100 text-foreground-800">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2.5" aria-label="漫天堂">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-extrabold tracking-wide text-foreground-950">
                漫天堂
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              聚合人气榜与热度排行，实时更新编辑推荐与高分漫画，帮你快速锁定当前最值得追的作品。
            </p>
          </div>

          <nav aria-label="分类导航">
            <h4 className="mb-4 text-sm font-bold text-foreground-950">分类榜单</h4>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {c.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="站点导航">
            <h4 className="mb-4 text-sm font-bold text-foreground-950">快捷入口</h4>
            <ul className="grid gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                  首页榜单
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#top" className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                  返回顶部
                </a>
              </li>
            </ul>
          </nav>

          <div>
            <h4 className="mb-4 text-sm font-bold text-foreground-950">联系我们</h4>
            <ul className="grid gap-2.5 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@mantiantang.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                <span>漫天堂官方公众号</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>每日 09:00–22:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-foreground-600 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 漫天堂 · 本站仅做漫画推荐与资讯分享</p>
          <p>人气榜 · 热度排行 · 高分推荐 · 编辑推荐</p>
        </div>
      </div>
    </footer>
  );
}